export const base64ToUint8Array = (base64) => {
  const binaryString = atob(base64.split(",")[1]);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const arrayBufferToBase64DataUrl = (buf) => {
  const bytes = new Uint8Array(buf);
  let binary = "";
  const chunk = 0x8000; // 32KB
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return "data:application/pdf;base64," + btoa(binary);
};

export const hasPDFHeader = (uint8Array) => {
  const header = new TextDecoder().decode(uint8Array.slice(0, 5));
  return header === "%PDF-";
};
